<section class="profile-page">
  <header>
    <h1>Mon profil</h1>
    <p>Mets à jour tes informations utilisateur.</p>
  </header>

  <p class="message error" *ngIf="errorMessage">{{ errorMessage }}</p>
  <p class="message success" *ngIf="successMessage">{{ successMessage }}</p>

  <div class="state loading-state" *ngIf="loading">
    <span class="spinner" aria-hidden="true"></span>
    <span>Chargement du profil…</span>
  </div>

  <div class="profile-layout" *ngIf="!loading">
    <aside class="panel identity">
      <div class="avatar">
        <img *ngIf="avatarPreviewUrl(); else avatarFallback" [src]="avatarPreviewUrl()!" alt="Avatar" />
        <ng-template #avatarFallback>
          <div class="placeholder">Aucun avatar</div>
        </ng-template>
      </div>
      <p class="email">{{ user?.email }}</p>
      <p class="role">{{ user?.role }}</p>
    </aside>

    <section class="panel editor">
      <form [formGroup]="form" (ngSubmit)="save()">
        <div class="grid two">
          <label>
            <span>Prénom</span>
            <input type="text" formControlName="firstname" />
          </label>
          <label>
            <span>Nom</span>
            <input type="text" formControlName="lastname" />
          </label>
        </div>

        <label>
          <span>Nom affiché</span>
          <input type="text" formControlName="displayName" />
        </label>

        <label>
          <span>Email</span>
          <input type="email" formControlName="email" />
        </label>

        <label>
          <span>Biographie</span>
          <textarea rows="4" formControlName="biography"></textarea>
        </label>

        <label>
          <span>Avatar URL</span>
          <input type="text" formControlName="avatarUrl" placeholder="images/avatar.jpg ou URL complète" />
        </label>

        <label class="file-input">
          <span>Uploader un avatar</span>
          <input type="file" accept="image/png,image/jpeg,image/webp" (change)="onAvatarFileSelected($event)" />
          <small class="inline-loading" *ngIf="uploadingAvatar">
            <span class="spinner sm" aria-hidden="true"></span>
            <span>Upload en cours…</span>
          </small>
        </label>

        <div class="actions">
          <button type="submit" class="primary" [disabled]="saving || uploadingAvatar">
            {{ saving ? 'Enregistrement…' : 'Mettre à jour le profil' }}
          </button>
        </div>
      </form>
    </section>
  </div>
</section>
